/**
 * Data Definition for a Box Plot Chart
 */
export class BoxPlotChartDataItem {
  lower: number;
  q1: number;
  median: number;
  q3: number;
  upper: number;
  mean: number;
  outliers: number[];
  category: string;
  color: string;
}
